import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../query/types';

const itemKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'items'] as const,
    export: [...keys, 'items', 'export'] as const,
  });

export { itemKeys };
